export default "__VITE_ASSET__3768d373__"